module.exports = __webpack_public_path__ + "static/media/kids_toys.f85606e9.png";